/**
 * @file Renders its children as small, secondary text.
 */
import React from "react";
import { Typography } from "antd";
import type { CSSProperties, ReactNode } from "react";

const { Text } = Typography;

type Props = {
  style?: CSSProperties;
  children: ReactNode;
};

const FONT_SIZE = 12;

/**
 * Renders its children as small, secondary text.
 */
const Small = ({
  style = {},
  children,
}: Props): JSX.Element => {
  return (
    <Text style={{ fontSize: FONT_SIZE, ...style }} type="secondary">
      {children}
    </Text>
  );
};

export default Small;
